export var WCIOptions = {
    DataZoom: [
        {
            type: "inside",
            start: 0,
            end: 100,
        },
        {
            show: true,
            type: "slider",
            top: "96%",
            start: 0,
            end: 100,
        },
    ],
    Grid: [{
        left: 200,
        right: 0,
        top: 20,
        height: "95%",
    }],
    xAxis: [{
        type: "category",
        boundaryGap: false,
        data: [],
    }],
    yAxis: [{
        type: "value",
        axisLabel: {
            formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                    return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                    return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                    return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
            },
        },
    }],
    legend:
    {
        data: [],
        type: "scroll",
        orient: "vertical",
        left: 10,
        top: 20,
        bottom: 20,
    }
}


export var WCITKOptions = {
    DataZoom: [
        {
            type: "inside",
            xAxisIndex: [0, 1],
            start: 0,
            end: 100,
        },
        {
            show: true,
            xAxisIndex: [0, 1],
            type: "slider",
            top: "96%",
            start: 0,
            end: 100,
        },
    ],
    Grid: [{
        left: 200,
        right: 200,
        top: 20,
        height: "45%",
    }, {
        left: 200,
        right: 200,
        top: "50%",
        height: "45%",
    }],
    xAxis: [{
        type: "category",
        boundaryGap: false,
        data: [],
    }, {
        type: "category",
        boundaryGap: false,
        gridIndex: 1,
        data: []
    }],
    yAxis: [{
        type: "value",
        axisLabel: {
            formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                    return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                    return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                    return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
            },
        },
    }, {
        type: "value",
        gridIndex: 1,
        axisLabel: {
            formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                    return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                    return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                    return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
            },
        },
    }],
    legend: [
        {
            data: [],
            type: "scroll",
            orient: "vertical",
            left: 10,
            top: 20,
            bottom: 20,
        },
        {
            data: [],
            gridIndex: 1,
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
        },
    ],
}